import { createSelector } from 'reselect';
import { RootState } from '../index';

const selectWorkflowsState = (state: RootState) => state.workflows;

export const selectWorkflows = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.workflows
);

export const selectSelectedWorkflow = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.selectedWorkflow
);

export const selectWorkflowsLoading = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.loading
);

export const selectWorkflowsError = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.error
);

export const selectUpdateWorkflowLoading = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.updateLoading
);

export const selectPublishWorkflowLoading = createSelector(
  [selectWorkflowsState],
  (workflows) => workflows.publishLoading
);
